export default __webpack_public_path__ + "static/newLogo-dadc6b3af5de38f999fed45013f6f3c3.webp";